import { ActionContainerCombinedProps } from './types';

const usePresenter = (props: ActionContainerCombinedProps): ActionContainerCombinedProps => {
  return props;
};

export default usePresenter;
